var render, staticRenderFns
import script from "./NumberStylePropertyEditableMixin.vue?vue&type=script&lang=ts&"
export * from "./NumberStylePropertyEditableMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports